export const LSK_AUTH_TOKEN = "auth-token";
export const LSK_REFRESH_TOKEN = "refresh-token";
export const LSK_USER = "user";

export const setItem = (key: string, data: string): void => {
  localStorage.setItem(key, data);
}


export const getItem = (key: string): string | null => {
  return localStorage.getItem(key);
}


export const setAuthToken = (token: string): void => {  
  localStorage.setItem(LSK_AUTH_TOKEN, token);
}

export const setRefreshToken = (refreshToken: string): void => {
  localStorage.setItem(LSK_REFRESH_TOKEN, refreshToken);
}


export const setUser = (data: object): void => {
  localStorage.setItem(LSK_USER, JSON.stringify(data));
}


export const getUser = (): object | null => {
  const userData = localStorage.getItem(LSK_USER);
  return userData ? JSON.parse(userData) : null;
}


export const getAuthToken = (): string | null => {
  return localStorage.getItem(LSK_AUTH_TOKEN);
}

export const getRefreshToken = (): string | null => {
  return localStorage.getItem(LSK_REFRESH_TOKEN);
}


export const removeUser = (): void => {
  localStorage.removeItem(LSK_USER);
}


export const removeAuthToken = (): void => {
  localStorage.removeItem(LSK_AUTH_TOKEN);
}
